import styled from 'styled-components'

export const Container = styled.div<{ color?: string }>`
  background-color: ${(props) => (props.color ? props.color : '#5b9bd5')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  overflow-y: auto;
  font-weight: 600;
  padding: 50px 40px 80px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
`;

export const ContentForm = styled.div`
  text-align: center;
  width: 100%;
  max-width: 920px;
  margin: 0 auto;
`;

export const Logo = styled.img`
  width: auto;
  max-height: auto; 

  &:first-child {
    margin-right: 50px;
  }
`

export const TitleDiv = styled.div`
  width: 90%;
  margin: auto;
  font-size: 2.8em;
  color: #FFFFFF;
  text-align: justify;
  word-spacing: -1px;
  margin-top: 0;
  line-height: 1.45;
`;

export interface OptionItemProps {
  selected: boolean;
}

export const OptionItemLabel = styled.label<{ selected: boolean }>`
  display: flex;
  align-items: center;
  font-size: 2.8em;
  cursor: pointer;
  color: #071e5b;
  font-weight: ${(props) => (props.selected ? 'bold' : '600')};
  padding: 5px 0;
  // color: ${(props) => (props.selected ? '#071e5b' : 'inherit')};
`;

export const RadioButton = styled.input`
  /* Hide default radio button */
  opacity: 0;
  position: absolute;
`;

export const AppContainerImageFinish = styled.div`
  background-color: #5b9bd5;
  min-height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Button = styled.button`
  background-color: white;
  color: black;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 300px;
  margin: auto;
  margin-top: 120px;
  font-size: 20px;
  font-weight: bold;
  border-radius: 5px;
`;

export const MessageFinal = styled.div`
  font-size: 2em;
  color: black;
  text-align: center;
  font-weight: 400;
  width: 100%;
  margin: 0 auto;
`

export const BtnButton = styled(Button)`
  width: 100%;
  font-size: 2.4em;
  color: #009933;
  background-color: #e1f7e8;
  border: 1px solid #009933;
  text-align: center;
  font-weight: bold;
  line-height: 2.4;
  margin-top: 50px;
  border-radius: 60px;
`;

// Crie um componente estilizado para centralização
export const CenteredContainer = styled.div`
  display: flex;
  background-color: #5b9bd5;
  // justify-content: center;
  align-items: center;
  flex-direction: column; /* Modificamos a direção para coluna */
  height: 100vh;
  width: 100vh;
  padding-top: 40%;
`

export const CenteredContainer2 = styled.div`
  display: flex;
  background-color: #5b9bd5;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
`

export const ReportContainer = styled.div`
  padding: 20px;
  border: 1px solid #ddd;
  width: 400px;
`;

export const Title = styled.h1`
  font-size: 24px;
  color: #333;
  text-align: center;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #ddd;
`;

export const TableHeader = styled.th`
  padding: 10px;
`;

export const TableCell = styled.td`
  padding: 10px;
  text-align: center;
`;

export interface ReportProps {
  data: { total_quantity_used: number; prize_description: string }[] | null;
}